import {Logger} from '../utils/Logger';
import {Step} from '../application-flow/steps/step';
import {UserService} from '../service/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {EmailStep} from '../application-flow/steps/email.step';
import {Keys, StorageService} from '../service/storage.service';
import { Component, OnInit, Type, ViewChild, Directive } from '@angular/core';
import {ApplicationFlowNavigator} from '../application-flow/application-flow.navigator';
import {LoanApplicationFlowNavigator} from '../application-flow/loan-application-flow.navigator';
import {AbstractApplicationFlowComponent} from '../application-flow/abstract-application-flow.component';
import {EmailVerificationFormComponent} from '../email-verification-form/email-verification-form.component';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';

@Directive()
export abstract class EmailVerificationComponent extends AbstractApplicationFlowComponent implements OnInit {
    finzyDomain = true;
    otherDomain = false;
    public email: string;
    public isBorrower: boolean;
    public loaderStatus = new LoaderStatus();
    @ViewChild(EmailVerificationFormComponent)
    emailVerificationForm: EmailVerificationFormComponent;
    protected readonly router: Router;
    protected readonly route: ActivatedRoute;
    private readonly storageService: StorageService;

    constructor(route: ActivatedRoute, router: Router, storageService: StorageService, public analyticsTracker: AnalyticsTracker,
                navigator: ApplicationFlowNavigator) {
        super(navigator);
        this.route = route;
        this.router = router;
        this.storageService = storageService;
    }

    public async navigateNext() {
        try {
            await executeWithLoader(this.loaderStatus, async () => {
                await this.emailVerificationForm.registerEmail();
                await this.navigateToNextStep();
            });
        } catch (error) {
            Logger.error(`An error occurred while associating email address with user. ${error}`);
        }
    }

    public async ngOnInit() {
        this.isBorrower = this.route.snapshot.url[0].path === 'borrow';
        if (this.storageService.getItem(Keys.DOMAIN) === 'tripfactory') {
            this.finzyDomain = false;
            this.otherDomain = true;
        } else {
            this.finzyDomain = true;
            this.otherDomain = false;
        }
    }

    step(): Type<Step> {
        return EmailStep;
    }

    public abstract async navigateBack(): Promise<void>;

    protected abstract async navigateToNextStep();

    protected errorMessages(): object {
        throw new Error('Method not implemented.');
    }
}

@Component({
    selector: 'app-email-verification',
    templateUrl: './email-verification.component.html',
    styleUrls: ['../../assets/styles/finzy-styles.scss', './email-verification.css'],
    providers: [UserService]
})
export class InvestmentApplicationEmailVerificationComponent extends EmailVerificationComponent {
    constructor(route: ActivatedRoute, router: Router, storageService: StorageService, analyticsTracker: AnalyticsTracker) {
        super(route, router, storageService, analyticsTracker, null);
    }

    async navigateBack(): Promise<void> {
        await this.router.navigate(['/invest/phone-verification'], {relativeTo: this.route});
    }

    protected async navigateToNextStep(): Promise<void> {
        await this.router.navigate(['../lenderpersonalinfo']);
    }
}

@Component({
    selector: 'app-email-verification',
    templateUrl: './email-verification.component.html',
    styleUrls: ['../../assets/styles/finzy-styles.scss', './email-verification.css', '../loan-application-flow-component/application-flow.css'],
    providers: [UserService]
})
export class LoanApplicationEmailVerificationComponent extends EmailVerificationComponent {
    constructor(route: ActivatedRoute, router: Router, storageService: StorageService,
                analyticsTracker: AnalyticsTracker, navigator: LoanApplicationFlowNavigator) {
        super(route, router, storageService, analyticsTracker, navigator);
    }

    async navigateBack(): Promise<void> {
        await this.previousPage();
    }

    protected async navigateToNextStep(): Promise<void> {
        await this.nextPage();
    }
}
